import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import GetOrganisationsRequestModel from '../../../../services/v2/model/get-organisations-request-model';
import LookupRequestModel from '../../../../services/v2/model/lookup-request-model';
import GuidEventLookupModel from '../../../../services/v2/model/guid-event-lookup-model';

export default class OrganisationsPage extends PageBase {
  public get organisationsList() {
    return this.organisationsDataSource.data?.items.map((i) => {
      return {
        ...i.data,
      };
    }) || [];
  }

  public set organisationsList(value) { /* Do nothing */ }

  public organisationsDataSource = new DataSource({
    selectCommand: () => {
      const request = new GetOrganisationsRequestModel();
      request.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      request.searchCriteria = this.organisationsDataSource.filter.searchCriteria;
      request.paging.currentPage = this.organisationsDataSource.paging.currentPage;
      request.paging.pageSize = this.organisationsDataSource.paging.pageSize;
      request.paging.includeCount = true;
      return Vue.$service.v2.api.tdg_Organisations.getOrganisations(request);
    },
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  public eventItems: GuidEventLookupModel[] | undefined;

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.organisationsDataSource.select();
  }

  async refreshInitialize(): Promise<void> {
    await this.organisationsDataSource.select();
  }

  public organisationColumns = [
    { value: Vue.$t('page.organisations.table.id'), textAlign: 'left', field: 'id' },
    { value: Vue.$t('page.organisations.table.orgsanisationName'), textAlign: 'left', field: 'organisationName' },
    { value: Vue.$t('page.organisations.table.organisationContactFirstName'), textAlign: 'left', field: 'organisationContactFirstName' },
    { value: Vue.$t('page.organisations.table.organisationContactLastName'), textAlign: 'left', field: 'organisationContactLastName' },
    { value: Vue.$t('page.organisations.table.organisationContactPhoneNumber'), textAlign: 'left', field: 'organisationContactPhoneNumber' },
    { value: Vue.$t('page.organisations.table.organisationContactEmail'), textAlign: 'left', field: 'organisationContactEmail' },
    { value: Vue.$t('page.organisations.table.externalId'), textAlign: 'left', field: 'externalId' },
    { value: Vue.$t('page.organisations.table.isSupporter'), textAlign: 'left', field: 'isSupporter' },
    { value: '', field: 'copyButton' },
    { value: '', field: 'editButton' },
  ];

  gotoDetail(id: string | number) {
    Vue.$router.push(`/_admin/organisations/edit/${id}`);
  }

  copyAccessToken(row: any) {
    const { externalId } = row;

    if (!externalId) {
      Vue.$log.error('No access token found for this organisation');
      return;
    }

    const tokenToCopy = typeof externalId === 'string'
      ? externalId
      : externalId.value || JSON.stringify(externalId);

    navigator.clipboard.writeText(tokenToCopy).then(() => {
      Vue.$log.info('Access token copied');
    }).catch((err) => {
      Vue.$log.error(`Failed to copy access token: ${err}`);
    });
  }

  async refreshOrganisations() {
    try {
      await this.refreshInitialize();
    } catch (error) {
      Vue.$log.error(`Error refreshing companies: ${error}`);
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
      }
    }
  }
}
